import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, Gift, CalendarDays, PartyPopper } from "lucide-react";
import api from "../console/api";
import { PromoCodes, Giveaway } from "./visit/VisitPromoGiveaway";

const TABS = [
  { id: "promo", label: "Promo codes", Icon: Ticket },
  { id: "giveaway", label: "Giveaway", Icon: Gift },
];

export default function AdminVisit() {
  const [tab, setTab] = useState("promo");
  const [promos, setPromos] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const load = useCallback(async () => {
    const [p, c] = await Promise.all([api.get("/admin/visit/promo-codes"), api.get("/admin/visit/campaigns")]);
    setPromos(p.data); setCampaigns(c.data);
  }, []);
  useEffect(() => { load().catch(() => {}); }, [load]);

  return (
    <div className="space-y-5" data-testid="admin-visit">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-[10px] tracking-[0.42em] uppercase font-semibold text-[#6E1E3A]">✦ Visit Heritage</div>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#3C2A1E] mt-1">Promo codes & giveaway</h1>
          <p className="text-sm italic text-[#7A6A55] mt-1">Private Picking availability and bookings live in <Link to="/admin/private-bookings" className="underline text-[#6E1E3A]" data-testid="admin-visit-bookings-link">Private Bookings</Link>. Open Day events and tickets live in <Link to="/admin/open-days" className="underline text-[#6E1E3A]" data-testid="admin-visit-open-days-link">Open Days & Tickets</Link>.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/admin/open-days" className="inline-flex items-center gap-2 h-10 px-4 rounded border text-xs font-semibold uppercase tracking-[0.2em]" style={{ borderColor: "#C9A268", color: "#3E1F46" }}><PartyPopper className="w-4 h-4" /> Open Days</Link>
          <Link to="/admin/private-bookings" className="inline-flex items-center gap-2 h-10 px-4 rounded border text-xs font-semibold uppercase tracking-[0.2em]" style={{ borderColor: "#C9A268", color: "#3E1F46" }}><CalendarDays className="w-4 h-4" /> Availability</Link>
        </div>
      </header>
      <nav className="flex flex-wrap gap-2 border-b border-[#E8DFCB] pb-2" data-testid="admin-visit-tabs">
        {TABS.map(({ id, label, Icon }) => (
          <button key={id} type="button" onClick={() => setTab(id)} data-testid={`admin-visit-tab-${id}`}
            className={`inline-flex items-center gap-1.5 px-3 h-9 rounded-full text-xs font-semibold uppercase tracking-[0.15em] ${tab === id ? "bg-[#3E1F46] text-white" : "bg-white border border-[#E8DFCB] text-[#5A4565]"}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        ))}
      </nav>
      {tab === "promo" && <PromoCodes promos={promos} reload={load} />}
      {tab === "giveaway" && <Giveaway campaigns={campaigns} promos={promos} reload={load} />}
    </div>
  );
}
